import { http } from "../index";
import Config from "../config/config";

const GetMenus = (data) => {
  return http.post({
    url: Config.Rules.GetMenus,
    data: data,
  });
};
const GetData = (data) => {
  return http.post({
    url: Config.Rules.GetData,
    data: data,
  });
};
const GetBranches = (lang) => {
  return http.get({
    url: Config.Branches.List.replace("{lang}", lang),
  });
};
const GetJackpots = {
  LiveCasino: () => {
    return http.get({ url: Config.Jackpots.LiveCasino });
  },
  IgrosoftHeader: () => {
    return http.get({ url: Config.Jackpots.IgrosoftHeader });
  },
  IgrosoftBody: () => {
    return http.get({ url: Config.Jackpots.IgrosoftBody });
  },
  LeaderPoker: () => {
    return http.get({ url: Config.Jackpots.LeaderPoker });
  },
};
export { GetMenus, GetData, GetBranches, GetJackpots };
